module.exports = __webpack_public_path__ + "img/life-at-ommax-2.52744259.jpg";